<f-data-card>
  <div class="container wrap-up">
    <div class="row">
      <h5>Wrap-up</h5>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6 wrap-up-left">

        <app-display-alert [id]="rootScope.activeCustTab.customerSessionId" [newAlert]="this.rootScope.isAlertAdded" [isLiveCall]="rootScope.isLiveCall"
          [newAlertId]="rootScope.newAlertId" [loadingFromWrapUpPage]='true'></app-display-alert>

      </div>
      <div class="col-md-12 col-lg-6 wrap-up-right">
        <h5 class="heading"> Topics and Details</h5>
        <div class="card-row flex-column row-margin">
          <span class="data-label">Customer Type </span>
          <span class="data-value">{{ getCustomerType()}}</span>
        </div>
        <div class="card-row" *ngIf="rootScope.activeCustTab?.customerType==tpConst">
          <div class="card-left">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Third Party/Other (Required)</mat-label>
              <mat-select disableRipple disableOptionCentering
                [(ngModel)]="rootScope.activeCustTab.wrapUpData.thirdParty"
                (selectionChange)="updateWrapUp($event)">
                <mat-option *ngFor="let thirdParty of rootScope.thirdPartyList"
                  [value]="thirdParty.fieldValueDescription">
                  {{ thirdParty.fieldValueDescription }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="card-row">
          <div class="card-left">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Interaction Type (Required)</mat-label>
              <mat-select disableRipple disableOptionCentering
                [(ngModel)]="rootScope.activeCustTab.wrapUpData.interactionTypeVal"
                (selectionChange)="updateWrapUp($event)">
                <mat-option *ngFor="let interactionType of interactionTypes" [value]="interactionType.fieldValue">
                  {{ interactionType.fieldValueDescription }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="card-row">
          <div class="card-left">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Interaction Mode (Required)</mat-label>
              <mat-select disableRipple disableOptionCentering
                [(ngModel)]="rootScope.activeCustTab.wrapUpData.interactionMode"
                (selectionChange)="onInteractionModeChange($event)">
                <mat-option *ngFor="let interactionMode of interactionModes" [value]="interactionMode.fieldValue">
                  {{ interactionMode.fieldValueDescription }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="card-right">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Interaction Mode Subtype (Required)</mat-label>
              <mat-select [disabled]="rootScope.activeCustTab.wrapUpData.interactionMode != 'Outbound'"
                disableOptionCentering [(ngModel)]="rootScope.activeCustTab.wrapUpData.interactionModeSubType"
                (selectionChange)="updateWrapUp($event)">
                <mat-option *ngFor="let interactionModeSubType of interactionModeSubTypes"
                  [value]="interactionModeSubType.fieldValue">
                  {{ interactionModeSubType.fieldValueDescription }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="card-row row-margin add-topic-row">
          <div class="add-topic-header">
            <span class="data-label">Topics (Required) </span>
            <div class="add-topic-controls">
              <button mat-icon-button class="add-topic" title="Add Topic" [disabled]="wrapupTopicList.length>=ten"
                (click)="addTopicModal()">
                <i class="fa-regular fa-circle-plus"></i>
              </button>

              <button mat-icon-button class="make-primary" title="Make Primary" [disabled]="wrapupTopicList?.length==0"
                (click)="makePrimary(topicIndex)">
                <i class="fa-solid fa-star-of-life"></i>
              </button>

              <button mat-icon-button class="delete-topic" title="Delete Topic" [disabled]="wrapupTopicList?.length==0 || isDefaultTopic(topicIndex)"
                (click)="deleteWrapupTopic(topicIndex)">
                <i class="fa-regular fa-trash-can"></i>
              </button>

            </div>
          </div>

          <span class="add-topic-container">
            <ng-container *ngFor="let data of wrapupTopicList; let index =index">
              <p tabindex="0" (click)="wrapupSelectedRow(data)" 
              (keydown)="onKeyDown($event,data)"
              [ngClass]="{ 'selected': topicIndex.id === data?.id }"
              aria-pressed="{ topicIndex.id===data?.id }"
              role="button">
                <span class="primary-sign"
                  *ngIf="rootScope.activeCustTab.wrapUpData.primaryTopic==data?.domain + topicArrow + data?.topic + topicArrow + data?.subTopic" tabindex="-1">*</span>
                {{data?.domain}} {{topicArrow}} {{data?.topic}} {{topicArrow}} {{data?.subTopic}}
              </p>
            </ng-container>
          </span>
          <span class="topic-notes"><strong>Note</strong>: A maximum of 10 topics can be selected.</span>

        </div>

        <div class="card-row topic-comments">
          <div class="add-topic-header">
            <span class="data-label"> Comments (Required)</span>
            <div class="mood">
              <span>
                <button mat-button1 class="kudos-btn" (click)="feedback(feedbackConst.kudos)"
                  *ngIf="rootScope.activeCustTab.wrapUpData.interactionFeedback!=feedbackConst.kudos"
                  [ngClass]="{'green-icon':rootScope.activeCustTab.wrapUpData.interactionFeedback==feedbackConst.kudos}">
                  <i class="fa-light fa-thumbs-up"></i>
                  <span>Kudos</span>
                </button>
                <button mat-button1 class="kudos-btn" (click)="feedback(feedbackConst.kudos)"
                  *ngIf="rootScope.activeCustTab.wrapUpData.interactionFeedback==feedbackConst.kudos"
                  [ngClass]="{'green-icon':rootScope.activeCustTab.wrapUpData.interactionFeedback==feedbackConst.kudos}">
                  <i class="fa-solid fa-thumbs-up"></i>
                  <span>Kudos</span>
                </button>
              </span>
              <span>
                <button mat-button1 class="dissatisfied-btn" (click)="feedback(feedbackConst.dissatiesfied)"
                  *ngIf="rootScope.activeCustTab.wrapUpData.interactionFeedback!=feedbackConst.dissatiesfied"
                  [ngClass]="{'red-icon':rootScope.activeCustTab.wrapUpData.interactionFeedback==feedbackConst.dissatiesfied}">
                  <i class="fa-light fa-thumbs-down"></i>
                  <span>Dissatisfied</span>
                </button>
                <button mat-button1 class="dissatisfied-btn" (click)="feedback(feedbackConst.dissatiesfied)"
                  *ngIf="rootScope.activeCustTab.wrapUpData.interactionFeedback==feedbackConst.dissatiesfied"
                  [ngClass]="{'red-icon':rootScope.activeCustTab.wrapUpData.interactionFeedback==feedbackConst.dissatiesfied}">
                  <i class="fa-solid fa-thumbs-down"></i>
                  <span>Dissatisfied</span>
                </button>
              </span>

            </div>

          </div>

          <div class="comment-textarea">
            <f-textarea [value]="rootScope.activeCustTab.wrapUpData.comments"
              [(ngModel)]="rootScope.activeCustTab.wrapUpData.comments" (textareaChanged)="onTextareaChanged($event)"></f-textarea>
          </div>
        </div>

        <div class="card-row ai-call-summary">

          <f-loading size="small"  *ngIf="rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryFetching"></f-loading>

          <button class="link"  [ngClass]="{'disabledLink': checkGetSummaryButtonEnabledOrDisabled()}" [disabled]="checkGetSummaryButtonEnabledOrDisabled()" (click)="onClickSummaries()"><span *ngIf="!rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryFetching"><i class="fa-light fa-sparkles"></i></span>Retrieve AI Call summary</button>
        
          <div class="error-wrapper" *ngIf="checkSummaryErrorMessage() || rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryApiError">    
            
            <f-alert variant="error" *ngIf="rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryApiError">
                  <p> There was problem loading the data. Press the button to try again.</p>
            </f-alert>

            <f-alert variant="info" in-container *ngIf="checkSummaryErrorMessage()">
              <p><strong>AI Call summary not available.</strong><br>
              Please enter your own comments and close the account. If the summary appears in Genesys prior to you closing the account, you may click the button to retry.</p>
            </f-alert>
        </div>


        
        </div>

        <div class="card-row close-account">
          <f-button class="btn-close" text="Close Account" title="Close Account" type="button"
            [disabled]="!updateWrapupStatus()" variant="progressive" (click)="closeAccountButtonClicked()">
          </f-button>
        </div>
        <div [ngClass]="{'error-gap':rootScope.activeCustTab?.wrapUpData?.callStatus?true:false}">
        <section *ngIf="rootScope.activeCustTab?.wrapUpData?.callStatus && enableSyncLink()"
        class="error-wrapper">
         <f-alert variant="error" class="error-without-heading">
           <p class="full-width">
             <strong>Interaction status could not sync.</strong> Try syncing again or contact support if this issue persists.
           </p>
         </f-alert>
       
       </section>
      </div>
        <div class="refresh-link-wrapup" *ngIf="enableSyncLink()">
          <button class="link" (click)="onClickLiveStatus()">Sync interaction status between ALIS and Care Portal.</button>
        </div>

      </div>



    </div>





  </div>
</f-data-card>


<!-- Add topic popup here -->

<app-customer-account-dialog id="addTopic" *ngIf="showAddTopicModal">

  <div id="content">
    <div class="topic-header alert-header">
      <h6>Add Topic</h6>
      <div class="close-btn">
      <button [appAutoFocus]="true" mat-icon-button mat-dialog-close (click)="closeAlertPopup()">
          <i class="fa-sharp fa-regular fa-xmark-large"></i>
        </button>
      </div>
    </div>

    <f-alert variant="info" class="status-msg " *ngIf="duplicateTopic?.domain">Please choose a unique
      combination of <b>
        {{duplicateTopic?.domain}} >> {{duplicateTopic?.topic}} >> {{duplicateTopic?.subTopic}}.</b>
    </f-alert>
    <div class="container form-scroll">
      <div class="row">
        <div class="col-md-12">
          <p>Select Topic</p>
        </div>
      </div>
      <form id="add-topic-form" [formGroup]="topicForm" (ngSubmit)="addTopic()">
        <div class="row">
          <div class="col-md-4">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Domain (Required)</mat-label>
              <mat-select disableRipple disableOptionCentering formControlName="domain">
                <mat-option *ngFor="let domain of domainList" [value]="domain?.topicName"
                  (onSelectionChange)="getTopicList(domain,$event)">
                  {{ domain?.topicName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Topic (Required)</mat-label>
              <mat-select disableRipple disableOptionCentering formControlName="topic" [disabled]="topicList.length==0">
                <mat-option *ngFor="let topic of topicList" [value]="topic.topicName"
                  (onSelectionChange)="getSubTopicList(topic,$event)">
                  {{ topic.topicName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Subtopic (Required)</mat-label>
              <mat-select disableRipple disableOptionCentering formControlName="subTopic"
                [disabled]="subTopicList.length==0">
                <mat-option *ngFor="let subtopic of subTopicList" [value]="subtopic.topicName">
                  {{ subtopic.topicName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 cta-row">
            <f-button text="Add" title="Add" type="button" variant="progressive" (click)="addTopic()"
              [ngClass]="{disableBtn:(topicForm.invalid || tableData.length>=ten || (wrapupTopicList.length+tableData.length>=ten))}"
              [disabled]="topicForm.invalid || tableData.length>=ten || (wrapupTopicList.length+tableData.length>=ten)"></f-button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12">
          <div class="topic-cta">

            <button mat-icon-button class="delete-topic" title="Delete Topic" [disabled]="tableData.length==0"
              (click)="deleteTopic(index)">
              <i class="fa-regular fa-trash-can"></i>
            </button>

          </div>

          <div class="table-container">


            <mat-table [dataSource]="dataSource">

              <!-- Domain Column -->
              <ng-container matColumnDef="domain">
                <mat-header-cell *matHeaderCellDef> Domain </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.domain}} </mat-cell>
              </ng-container>

              <!-- topic Column -->
              <ng-container matColumnDef="topic">
                <mat-header-cell *matHeaderCellDef> Topic </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.topic}} </mat-cell>
              </ng-container>

              <!-- Subtopic Column -->
              <ng-container matColumnDef="subTopic">
                <mat-header-cell *matHeaderCellDef> Subtopic </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.subTopic}} </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns; let i = index" (click)="selectedRow(i)"
                [ngClass]="{ 'selected-row': i === index }"></mat-row>
            </mat-table>
            <div class="no-result hide1" *ngIf="tableData.length==0">
              <p>Please add topics on the form above. </p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="button-controls">
      <f-button text="Clear all" title="Clear all" type="button" variant="action" (click)="clearTopic()"></f-button>
      <f-button text="Submit" title="Submit" type="button" variant="progressive" [ngClass]="{disableBtn:tableData.length==0}"
        [disabled]="tableData.length==0" (click)="submitTopic()"></f-button>
    </div>
  </div>
</app-customer-account-dialog>
<!-- Add topic popup close here -->